export class Resource {
  id!: string;
  loading = false;
  selected = false;
  classes = '';
  // eslint-disable-next-line @typescript-eslint/member-ordering
  [key: string]: any;
}
